import "./Promote.css";

const PromoteImg = () => {
	return (
		<div className="promote-photo">
			<img src="/assets/images/Promote/resources.jpg" alt="promote" loading="lazy" />
		</div>
	);
};
export default PromoteImg;

